import React, { useState, useEffect  } from 'react';
import { apiFetch } from '../api/api';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import { useOrg } from '../pages/orgs/org-context';
import Logo from '../assets/EveryID.png';
import { useBranding } from '../contexts/BrandingContext';
import { useHelp } from '../help/HelpContext';
import "../styles/Buttons.css";


export default function Header({ toggleSidebar }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { orgs, activeOrg, switchOrg } = useOrg();
  const [open, setOpen] = useState(false);
  const { branding, loading } = useBranding();
  const { openHelp } = useHelp();

  const visibleOrgs =
    ((user?.roles === 'superadmin') ||
    (user?.roles === 'org:admin'))
      ? orgs
      : (activeOrg ? [activeOrg] : []);


  return (
    <header className="header">
      <div className="header-left">
        <button onClick={toggleSidebar} className="hamburger">&#9776;</button>
        {loading ? (

          <div
            style={{
              width: 180,
              height: 36
            }}
          />

        ) : (

          <img
            src={
              branding?.headerLogoUrl ||
              Logo
            }
            alt={
              branding?.brandName ||
              'EveryID'
            }
            onClick={() =>
              navigate('/homepage')
            }
            style={{
              cursor:'pointer',
              height:36,
              maxWidth:220,
              objectFit:'contain'
            }}
          />

        )}
      </div>

      <div className="org-switcher">
      <button
        className="btn-selector"
        onClick={() => setOpen(o => !o)}
      >
        {activeOrg ? activeOrg.organization : 'Select organization'}
        <span className="chevron">▾</span>
      </button>

        {open && (
          <div className="org-dropdown">
            {orgs.map(org => (
              <div
                key={org._id}
                className={`org-option ${
                  activeOrg?._id === org._id ? 'active' : ''
                }`}
                onClick={async () => {
                  await switchOrg(org._id);
                  setOpen(false);
                  navigate('/homepage');
                {/*  window.location.reload(); */}
                }}
              >
                {org.organization}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="profile-section">

        <button
          className="btn-gray"
          onClick={() => openHelp()}
        >
          ? Help
        </button>

        <span className="user-name">
          {user?.firstName}
        </span>

        <button
          className="btn-return"
          onClick={logout}
        >
          Logout
        </button>

      </div>
    </header>
  );
}
